<template>
  <div>
    <div v-if="$vuetify.breakpoint.smAndDown" class="text-center">
      <v-img
        :width="72"
        :height="72"
        class="col-auto mt-6 mx-auto"
        :src="$asset(`img/icons/${formSent ? 'check_circle.svg' : 'person-happy.svg'}`)"
      />
      <div
        class="mt-4 mt-md-6 mb-4 text-h1"
        v-html="formSent ? $t('feedback.thankYou.title') : $t('feedback.title')"
      />
    </div>
    <div
      :class="{
        'text-center': $vuetify.breakpoint.mdAndDown
      }"
      v-html="formSent ? $t('feedback.thankYou.text') : $t('feedback.text')"
    />
    <template v-if="!formSent">
      <div class="feedback__separator mt-6" />
      <RatingStars :rating="rating" class="my-4" @clickRating="setRatingStar" />
      <div class="feedback__separator mb-6" />
      <FeedbackTextarea />
    </template>
  </div>
</template>

<script>
import RatingStars from '@/components/Atoms/RatingStars.vue';
import FeedbackTextarea from '@/feature/feedback/components/FeedbackTextarea.vue';
import { useFeedback } from '@/feature/feedback/composables/useFeedback.js';

export default {
  name: 'FeedbackContent',
  components: { FeedbackTextarea, RatingStars },
  setup() {
    const { formSent, rating, setRating, setFormSent } = useFeedback();
    return { formSent, rating, setRating, setFormSent };
  },
  async beforeCreate() {
    this.$store.commit('profile/feedback/setFormSent', false);
  },
  methods: {
    async setRatingStar(item) {
      this.$gtm.push({
        event: 'form_progress',
        'form.field': 'feedback hodnoceni hvezdy',
        'form.name': 'feedback'
      });
      await this.setRating(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback__separator {
  border-bottom: $border-width solid $grey-lighten;
}
</style>
